export default "__VITE_ASSET__DpCJelhp__"